<template>
  <div class="sidebar">
    <div class="sidebar-header">
      <img
        :src="getCurrentAgentAvatar()"
        alt="Image de l'agent actuel"
        class="avatar"
        style="
          width: 24px;
          height: 24px;
          border-radius: 50%;
          margin-right: 0.5rem;
        "
      />
      <span>Assistant IA</span>
    </div>

    <div
      v-for="(agent, index) in agents"
      :key="index"
      :class="['nav-item', { active: currentAgent === agent.id }]"
      @click="selectAgent(agent.id)"
    >
      <span class="sidebar-text">{{ agent.name }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "ChatSidebar",
  props: {
    agents: {
      type: Array,
      required: true,
    },
    currentAgent: {
      type: String,
      default: "thomas",
    },
  },
  emits: ["select-agent"],
  setup(props, { emit }) {
    function selectAgent(agentId) {
      emit("select-agent", agentId);
    }

    function getCurrentAgentAvatar() {
      const agent = props.agents.find(
        (agent) => agent.id === props.currentAgent
      );
      return agent ? agent.avatar : null;
    }

    return {
      selectAgent,
      getCurrentAgentAvatar,
    };
  },
};
</script>

<style scoped>
.sidebar {
  width: 260px;
  background: var(--main);
  border-right: 1px solid #e5e7eb;
  padding: 1rem;
}

.sidebar-header {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem;
  margin-bottom: 1rem;
}

.nav-item {
  display: flex;
  align-items: center;
  padding: 0.75rem;
  margin: 0.25rem 0;
  border-radius: 0.5rem;
  cursor: pointer;
  transition: background-color 0.2s;
}

.nav-item:hover {
  background: #f3f4f6;
}

.nav-item.active {
  background: var(--secondary);
  color: var(--secondary-content);
}

.sidebar-text {
  display: block;
}

@media (max-width: 768px) {
  .sidebar {
    width: 60px;
  }
}
</style>
